import React from 'react';
import { Hero } from '../components/Hero';
import { ProofBar } from '../components/ProofBar';
import { PatternInterrupt } from '../components/PatternInterrupt';
import { ProblemAgitation } from '../components/ProblemAgitation';
import { SystemBreakdown } from '../components/SystemBreakdown';
import { SystemFramework } from '../components/SystemFramework';
import { QuickWin } from '../components/QuickWin';
import { AuthorityTimeBlock } from '../components/AuthorityTimeBlock';
import { Pricing } from '../components/Pricing';
import { AuthorityClose } from '../components/AuthorityClose';
export function LandingPage() {
  return <main className="bg-luxury-black min-h-screen text-white selection:bg-luxury-gold selection:text-luxury-black" data-id="element-197">
      <Hero data-id="element-198" />
      <ProofBar data-id="element-199" />
      <PatternInterrupt data-id="element-200" />
      <ProblemAgitation data-id="element-201" />
      <SystemBreakdown data-id="element-202" />
      <SystemFramework data-id="element-203" />
      <QuickWin data-id="element-204" />
      <AuthorityTimeBlock data-id="element-205" />
      <Pricing data-id="element-206" />
      <AuthorityClose data-id="element-207" />
    </main>;
}